import { WRITE_OFF_REASONS } from '../../../../constants/reasons';

export const handleReasonChange = (changeField, resetField) => (event) => {
  const [code, label] = event.target.value.split('_');
  changeField('reasonCode')(code);
  changeField('label')(label);
  resetField('additionalExplanation');
};

export const handleAllFeesChange = (changeField, includedFields) => (checked) => {
  Object.keys(includedFields).forEach((field) => {
    changeField(field)(Boolean(includedFields[field] && checked));
  });
};

export const validateReasonCode = (includeReason) => (values) => {
  const { reasonCode } = values;

  return !includeReason || reasonCode !== '';
};

export const validateAdditionalExplanation = () => (values) => {
  const { reasonCode, additionalExplanation } = values;
  const reason = WRITE_OFF_REASONS.find((r) => r.code === reasonCode);

  return reason ? !reason.requiresAdditional || !additionalExplanation.match(/^\s*$/) : true;
};

export const validateLabel = () => (values) => !!values.label;
